<template>
  <el-dialog
    title="修改密码"
    :visible.sync="dialogVisible"
    width="30%"
    :before-close="handleClose"
  >
    <el-form ref="formLabelAlign" label-width="110px" :model="formLabelAlign">
      <el-form-item
        label="输入旧密码"
        prop="oldpassword"
        :rules="{ required: true, message: '请输入旧密码', trigger: 'blur' }"
      >
        <el-input
          v-model="formLabelAlign.oldpassword"
          placeholder="输入旧密码"
          show-password
          class="inputs"
        />
      </el-form-item>
      <el-form-item
        label="输入新密码"
        prop="newpassword"
        :rules="{ required: true, message: '请输入新密码', trigger: 'blur' }"
      >
        <el-input
          v-model="formLabelAlign.newpassword"
          placeholder="输入新密码"
          type="passwrod"
          show-password
          class="inputs"
        />
      </el-form-item>
      <el-form-item
        label="确认新密码"
        prop="alterpassword"
        :rules="{ required: true, message: '请输入新密码', trigger: 'blur' }"
      >
        <el-input
          v-model="formLabelAlign.alterpassword"
          placeholder="确认新密码"
          type="passwrod"
          show-password
          class="inputs"
        />
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="submitForm('formLabelAlign')"
        >确认修改</el-button>
        <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
// import { Base64 } from 'js-base64'

const base64 = require('js-base64').Base64
export default {
  data() {
    return {
      dialogVisible: false,
      formLabelAlign: {
        oldpassword: '',
        newpassword: '',
        alterpassword: ''
      }
    }
  },
  computed: {
    Bmassage: function() {
      const baseUserId = base64.decode(this.$store.getters.token.split('.')[1])
      return JSON.parse(baseUserId)
    }
  },
  created() {
    // 创建
    this.$EventBus.$on('amendpass', () => {
      this.dialogVisible = true
      this.formLabelAlign.oldpassword = ''
    })
  },
  methods: {
    handleClose(done) {
      this.formLabelAlign.newpassword = ''
      this.formLabelAlign.oldpassword = ''
      this.formLabelAlign.alterpassword = ''
      done()
    },
    submitForm(formLabelAlign) {
      this.$refs[formLabelAlign].validate(valid => {
        if (valid) {
          if (
            this.formLabelAlign.newpassword !==
            this.formLabelAlign.alterpassword
          ) {
            return this.$message.error('两次密码输入的不同')
          }
          this.dataList()
        } else {
        }
      })
    },
    async dataList() {
      let urlPass = 'member/updatepass'
      if (this.Bmassage.userRole === '05') {
        urlPass = 'childuser/updatePass'
      }
      const userId = this.Bmassage.userId
      const response = await this.$axios.put(
        '/api/' +
          urlPass +
          '?password=' +
          this.formLabelAlign.newpassword +
          '&userId=' +
          userId +
          '&oldPassword=' +
          this.formLabelAlign.oldpassword,
        {},
        {
          headers: { Authorization: this.$store.getters.token }
        }
      )
      if (response.data.code === 434) return this.$message('原密码不正确!')
      if (response.data.code !== 200) { return this.$message('修改失败，请刷新重试') }

      this.$message.success('修改成功!')
      this.formLabelAlign.newpassword = ''
      this.formLabelAlign.oldpassword = ''
      this.formLabelAlign.alterpassword = ''
      this.dialogVisible = false
    }
  }
}
</script>

<style>
.inputs {
  width: 200px;
}
</style>
